import React from 'react';
import { Typography, Box, Paper } from '@mui/material';
import Layout from '../../components/Layout';

const AdminComercios: React.FC = () => {
  return (
    <Layout>
      <Box>
        <Typography variant="h4" gutterBottom>
          Gestión de Comercios
        </Typography>
        
        <Paper sx={{ p: 3, mt: 2 }}>
          <Typography variant="h6" gutterBottom>
            Comercios - En Desarrollo
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Esta sección permitirá gestionar los comercios afiliados.
            Funcionalidades incluidas:
          </Typography>
          <Box component="ul" sx={{ mt: 2 }}>
            <li>Registrar nuevos comercios con validación de RUC</li>
            <li>Activar/desactivar comercios</li>
            <li>Resetear contraseñas temporales</li>
            <li>Ver estadísticas de cada comercio</li>
            <li>Gestionar datos de contacto</li>
            <li>Generar reportes de uso</li>
          </Box>
        </Paper>
      </Box>
    </Layout>
  );
};

export default AdminComercios;
